import { render, staticRenderFns } from "./RedesEcontatos.vue?vue&type=template&id=bda5054e&scoped=true&lang=pug"
import script from "./RedesEcontatos.vue?vue&type=script&lang=js"
export * from "./RedesEcontatos.vue?vue&type=script&lang=js"
import style0 from "./RedesEcontatos.styl?vue&type=style&index=0&id=bda5054e&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda5054e",
  null
  
)

export default component.exports